import { useState, useEffect } from 'react';
import { trackService, TracksListResponse } from 'data/services/trackService';
import { Track } from 'domain/track/trackContainer';

export const useTracksList = (page: number = 0, limit: number = 20, sort: string = 'CreatedAt desc', status?: 'Draft' | 'Publish', match?: string) => {
  const [data, setData] = useState<TracksListResponse | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTracks = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      const filterBy = status ? [{ Status: status }] : undefined;
      const response = await trackService.getTracks(page, limit, sort, match, filterBy);
      setData(response);
    } catch (err: any) {
      console.error('❌ Erro ao buscar trilhas:', err);
      setError(err?.response?.data?.message || 'Erro ao carregar trilhas');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTracks();
  }, [page, limit, sort, status, match]);

  const refetch = () => {
    fetchTracks();
  };

  const transformedTracks: Track[] = data?.rows?.map(track => {
    let mappedStatus: Track['status'];
    if (track.status === 'Draft') {
      mappedStatus = 'rascunho';
    } else if (track.status === 'Publish') {
      mappedStatus = 'publicado';
    } else {
      mappedStatus = track.status as Track['status'];
    }
    
    const transformedTrack: Track = {
      id: track.id,
      title: track.title,
      lessons: track.numberOfLessons,
      numberOfLessons: track.numberOfLessons,
      status: mappedStatus,
      imageUrl: track.imageUrl,
      length: track.totalOfMinutes,
      totalOfMinutes: track.totalOfMinutes,
      description: track.description,
      createdAt: track.createdAt,
    };
    
    return transformedTrack;
  }) || [];

  return {
    data: {
      rows: transformedTracks,
      totalPages: data?.totalPages || 0,
      totalRows: data?.totalRows || 0,
      page: data?.page || 0,
      limit: data?.limit || 0,
    },
    isLoading,
    error,
    refetch,
  };
};